import { render, staticRenderFns } from "./PersonalDetails.vue?vue&type=template&id=a6e3748a&scoped=true"
import script from "./PersonalDetails.vue?vue&type=script&lang=js"
export * from "./PersonalDetails.vue?vue&type=script&lang=js"
import style0 from "./PersonalDetails.vue?vue&type=style&index=0&id=a6e3748a&prod&scoped=true&lang=css"
import style1 from "./PersonalDetails.vue?vue&type=style&index=1&id=a6e3748a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e3748a",
  null
  
)

export default component.exports